<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8wrh0w/tc-custom/9781504063357.jpg?1728396548245" alt="This image is the cover for the book Light of Western Stars, Light of Western Stars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Light of Western Stars, Light of Western Stars
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This 1914 novel of frontier romance by “the greatest Western writer of all time” was the basis for the classic film starring Victor Jory (Jackson Cain, author of <i>Hellbreak Country</i>).</b></p><p>Feeling constrained by her high-society life back east, Madeline Hammond decides to join her brother Alfred at his cattle ranch in El Cajon, New Mexico. But she gets a rude introduction to frontier living when she encounters a drunken cowboy named Gene Stewart. Though his rough demeanor is a shock to Madeline’s refined sensibilities, she comes to realize that he means no harm—and soon learns there are far worse characters for her to worry about.</p> There are some bad men who would do anything to see Alfred run off his land. While Gene tries to prove to Madeline that he can change for the better, tensions in El Cajon are on the rise. And when violence breaks out, Madeline discovers courage matters a lot more than manners on the frontier
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zane Grey
      </h2>
      
      <p class="authorDescription body article">Zane Grey (1872&ndash;1939) was born in Zanesville, Ohio, a city named for a Revolutionary War hero who was his ancestor. After attending the University of Pennsylvania on a baseball scholarship, he started a dentistry practice in New York City and wrote in the evenings. An avid outdoorsman, Grey found his inspiration in the American West, and his bestselling novels, including the iconic <I>Riders of the Purple Sage</I>, established the conventions and the enduring popularity of the Western genre.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a89f232